import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ContentLayout, StepperCard } from '@ibk/shared-layout';
import { Icon } from '@ibk/shared-ui';
import { ContractSummarySidebar } from '../ContractSummarySidebar';
import styles from './HiringFeedbackLayout.module.css';
import { useHiringFeedbackSidebar } from './hooks/useHiringFeedbackSidebar';
import { useIsEmissorFeedbackFlow } from './hooks/useIsEmissorFeedbackFlow';
export function HiringFeedbackLayout({ iconName, iconAlt, iconClassName, iconContainerClassName, title, description, buttonLabel, onGoToBenefits, }) {
    const navigate = useNavigate();
    const isEmissorFlow = useIsEmissorFeedbackFlow();
    const { sidebarData, currentStep, breadcrumbs } = useHiringFeedbackSidebar();
    const handleGoToBenefitsClick = () => {
        if (onGoToBenefits) {
            onGoToBenefits();
        }
        else {
            navigate('/beneficios');
        }
    };
    const renderSummaryCard = () => (_jsx(ContractSummarySidebar, { steps: sidebarData.steps, address: sidebarData.address, employeeCount: sidebarData.employeeCount, productFamilies: sidebarData.productFamilies }));
    const renderMainCard = () => (_jsx(StepperCard, { currentStep: currentStep, showStepper: !isEmissorFlow, actions: {
            next: {
                label: buttonLabel,
                onClick: handleGoToBenefitsClick,
                disabled: false,
            },
        }, children: _jsx("div", { className: styles.stepContent, children: _jsxs("div", { className: `${styles.activationFeedbackContent} ${isEmissorFlow ? styles.emissorFeedbackContent : ''}`, children: [_jsx("div", { className: `${iconContainerClassName} ${isEmissorFlow ? styles.emissorIconContainer : ''}`, children: _jsx(Icon, { name: iconName, alt: iconAlt, className: `${iconClassName} ${isEmissorFlow ? styles.emissorIcon : ''}` }) }), _jsx("h1", { className: `${styles.title} ${isEmissorFlow ? styles.emissorTitle : ''}`, children: title }), typeof description === 'string' ? (_jsx("p", { className: `${styles.description} ${isEmissorFlow ? styles.emissorDescription : ''}`, dangerouslySetInnerHTML: { __html: description } })) : (_jsx("p", { className: `${styles.description} ${isEmissorFlow ? styles.emissorDescription : ''}`, children: description }))] }) }) }));
    if (isEmissorFlow) {
        return (_jsx(ContentLayout, { breadcrumbs: breadcrumbs, showSidebar: false, noMaxWidth: true, children: renderMainCard() }));
    }
    return (_jsx(ContentLayout, { breadcrumbs: breadcrumbs, sidebar: renderSummaryCard(), children: renderMainCard() }));
}
